module.exports = __webpack_public_path__ + "static/media/soc-website.d535118c.png";